import mongoose from 'mongoose'
import Wallet from './wallet'


export const  subscriptionsSchema = mongoose.Schema({
    user:{
        type:mongoose.Schema.Types.ObjectId,
        ref:"User"
    },
    wallet:{
        type:mongoose.Schema.Types.ObjectId,
        ref:"Wallet"
    }
},{collection:"subscriptions"});
subscriptionsSchema.statics = {
    getWallets:async (data)=>{

        return data.map(async(subscription)=>{
             return await Wallet.findOne({_id:subscription.wallet}).populate("owner").exec()

        });

    }
}
export default mongoose.model('Subscriptions',subscriptionsSchema)